import React from 'react'

import { Box } from '../Shared/Base'
import { useScript } from '../Shared/hooks'

export const SignGoogleButton = ({ onSuccess, oauth_url }) => {
  const ref_div = React.useRef(null)
  const status = useScript('https://accounts.google.com/gsi/client')

  const onGoogleSuccess = React.useCallback(
    async ({ credential }) => {
      onSuccess({
        oauth_url,
        oauth_body: {
          google_idtoken: credential
        }
      })
    },
    [onSuccess, oauth_url]
  )

  React.useEffect(() => {
    if (status === 'ready') {
      window.google.accounts.id.initialize({
        client_id: '52860726047-m1bmqpao2vvvap2f7b7o8l9c7uhj7lvg.apps.googleusercontent.com',
        callback: onGoogleSuccess,
        auto_select: false
      })
      window.google.accounts.id.renderButton(
        ref_div.current,
        { theme: 'outline', size: 'large' } // customization attributes
      )
    }
  }, [onGoogleSuccess, status])

  return <Box ref={ref_div} />
}
